<template>
  <div class="login">
    <div class="presentation-login">
      <div class="column items-center q-py-xl">
        <div class="presentation-login__img-logo">
          <img alt="Logo" src="@/assets/img/logo_impetus.png" />
        </div>

        <div class="presentation-login__img-logomarca">
          <img alt="Logo" src="@/assets/img/logomarca_appembarque_white.png" />
        </div>
      </div>
      <div>
        <q-separator></q-separator>
        <div class="row justify-center">
          <q-btn
            to="/history-travel"
            flat
            unelevated
            color="white"
            class="presentation-login__history"
          >
            <q-icon name="history" />
            <q-space></q-space>
            <span style="font-weight: 500">Ver histórico da última viagem</span>
            <q-space></q-space>
            <q-icon name="arrow_right" />
          </q-btn>
        </div>
      </div>
    </div>

    <div>
      <q-tabs v-model="tab" left-icon no-caps class="bg-grey-1" active-color="teal-10">
        <q-tab
          clickable
          @click="stopNFC()"
          name="loginPassword"
          label="Entrar com senha"
          icon="vpn_key"
          style="padding: 0 10px"
        />
        <q-tab
          clickable
          @click="startNFC()"
          name="nfc"
          label="Entrar por aproximação"
          icon="nfc"
          style="padding: 0 10px"
        />
      </q-tabs>
      <div v-if="tab === 'loginPassword'">
        <form @submit.prevent="logar" class="presentation-login__form">
          <h1 class="presentation-login__title">ENTRE COM SEUS DADOS DO IMPETUS</h1>
          <q-input
            v-model="username"
            required
            filled
            lazy-rules
            color="teal-8"
            label="Usuário"
            type="text"
            input-class="text-uppercase"
            :rules="[ (val) => !!val || 'Por favor informe o usuário']"
          >
            <template v-slot:prepend>
              <q-icon name="person_outline" />
            </template>
          </q-input>

          <q-input
            v-model="password"
            required
            filled
            lazy-rules
            color="teal-8"
            label="Senha"
            :rules="[ (val) => !!val || 'Por favor informe a senha']"
            :type="isPwd ? 'password' : 'text'"
          >
            <template v-slot:prepend>
              <q-icon name="lock" />
            </template>
            <template v-slot:append>
              <q-icon
                :name="isPwd ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="isPwd = !isPwd"
              />
            </template>
          </q-input>
          

          <div class="row justify-center">
            <q-btn
              unelevated
              no-caps
              label="Entrar no aplicativo"
              type="submit"
              text-color="white"
              class="presentation-login__button"
            />
          </div>
        </form>
      </div>

      <div v-else-if="tab === 'nfc'" class="column justify-center items-center">
        <h6 class="text_nfc">Aproxime o celular do seu crachá</h6>
        <q-spinner-rings color="teal-8" size="150px" class="q-mt-lg" />
      </div>

      <div class="link_eulabs">
        <span>DESENVOLVIDO POR</span><br />
        <a href="https://eulabs.com.br/" target="_blank"
          >EULABS - SOLUÇÕES EM TECNOLOGIA</a
        >
      </div>

      <div class="text_version">
        <span>V. {{version}}</span>
      </div>
    </div>

    <!-- <q-dialog
      v-if="!dialogConnectionOff"
      v-model="validVersion"
      persistent
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Existe uma nova versão</div>
        </q-card-section>

        <q-card-section class="q-pt-none row items-center">
          <img alt="App Icon" src="@/assets/img/app_img.png" style="width: 50px" />
          <div class="column q-pl-sm">
            <span>Eucatur Embarque</span>
            <span>{{versionDB}}</span>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white">
          <q-btn
            @click="openURL(urlApp)"
            unelevated
            no-caps
            label="Atualizar agora"
            class="q-py-xs q-px-sm text-weight-bold"
            text-color="white"
            style="background-color: #23C400"
          />
        </q-card-actions>
      </q-card>
    </q-dialog> -->

    <q-dialog
      v-model="dialogConnectionOff"
      persistent
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6 row items-center">
            Problemas com a internet
            <i class="ri-signal-wifi-error-line q-pl-sm"></i>
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none row items-center">
          <div class="column q-pl-sm">
            <span>Verifique se você está conectado a internet</span>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white">
          <q-btn
            @click="checkVersionAndConnection()"
            unelevated
            no-caps
            label="Verificar agora"
            class="q-py-xs q-px-sm text-weight-bold"
            text-color="white"
            style="background-color: #23C400"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="appNewsDialog"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 100%">
        <q-card-section class="row items-center q-pb-none">
          <q-space />
          <q-btn icon="cancel" color="grey-7" flat round dense v-close-popup/>
        </q-card-section>

        <q-card-section class="login__newsApp--dialog">
          <h6 class="login__newsApp--title">NOVIDADE</h6>
          <img alt="Logomarca do Impetus" src="@/assets/img/arrow_impetus_green.png" />

          <span class="login__newsApp--title">Agora o APP de embarque rápido está de cara nova</span>
          <span class="login__newsApp--description">Fique tranquilo que tudo continua simples e fácil como antes.</span>
          <span class="login__newsApp--description q-mb-md">Temos novas cores e algumas melhorias.</span>

          <q-btn
            v-close-popup
            unelevated
            no-caps
            label="Continuar"
            class="presentation-login__button"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { getHost, setLocalStorage, vaiParaUrl } from "../functions";

import {
  TOKEN,
  USER,
  USER_AGENCY,
  USER_AGENCY_CODE,
  USER_AGENCY_NAME,
  USER_MOTORIST,
  USER_ID,
  FIRST_ACCESS,
} from "../variables";

import { mutations } from "../store";
import { openURL } from "quasar";

export default {
  computed: {
    validVersion: {
      get() {
        return this.versionDB !== this.version ? true : false;
      },
    },
  },
  mounted() {
    if (!window.localStorage.getItem(FIRST_ACCESS)) window.localStorage.setItem(FIRST_ACCESS, false)
    this.checkVersionAndConnection();
  },
  data() {
    return {
      username: "",
      password: "",
      tab: "loginPassword",
      version: "3.0.0",
      versionDB: "",
      urlApp:
        "https://play.google.com/store/apps/details?id=br.com.eucatur.app_embarque&hl=pt_BR",
      dialogConnectionOff: false,
      isPwd: true,
      appNewsDialog: !window.localStorage.getItem(FIRST_ACCESS),
    };
  },

  beforeDestroy() {
    this.stopNFC();
  },

  methods: {
    openURL,
    checkVersionAndConnection() {
      window.http
        .get(`${getHost()}/eucaturmobile/version`)
        .then(() => {
          if (this.dialogConnectionOff) {
            mutations.openAlert({
              open: true,
              message: "Conexão restabelecida.",
              status: 200,
            });
          }
          this.dialogConnectionOff = false;
          // this.versionDB = r.data.version;
          // if (r.data.version !== this.version) {
          //   openURL(this.urlApp);
          // }
        })
        .catch((e) => {
          if (!e.response) {
            this.dialogConnectionOff = true;
          }
        });
    },
    startNFC() {
      this.readNFC();
    },
    stopNFC() {
      if (this.$q.platform.is.cordova) {
        nfc.removeNdefListener(
          function (nfcEvent) {
            console.log(nfcEvent);
          },
          function () {
            // success callback
          },
          function (error) {
            // error callback
            console.log("Error adding NDEF listener " + JSON.stringify(error));
          }
        );
      }
    },

    logar() {
      const { username, password } = this;
      window.http
        .post(`${getHost()}/eucaturmobile/login`, { username, password })
        .then((r) => {
          const user = r.data;
          setLocalStorage(USER_ID, user.id);
          setLocalStorage(USER, user.name);
          setLocalStorage(USER_AGENCY, user.agency);
          setLocalStorage(USER_AGENCY_CODE, user.agency_code);
          setLocalStorage(USER_AGENCY_NAME, user.agency_name);
          setLocalStorage(USER_MOTORIST, user.motorist);
          setLocalStorage(TOKEN, user.token);
          mutations.setLogged(true);
          vaiParaUrl("/pesquisar");
        });
    },
    readNFC() {
      if (this.$q.platform.is.cordova) {
        // Read NDEF formatted NFC Tags
        nfc.addNdefListener(
          function (nfcEvent) {
            var tag = nfcEvent.tag,
              ndefMessage = tag.ndefMessage;
            // assuming the first record in the message has
            // a payload that can be converted to a string.
            let nfcTagValues = JSON.parse(
              nfc.bytesToString(ndefMessage[0].payload).substring(3)
            );

            window.http
              .post(`${getHost()}/eucaturmobile/login`, {
                type_login: "nfc",
                cpf: nfcTagValues.cpf,
              })
              .then((r) => {
                const user = r.data;
                setLocalStorage(USER_ID, user.id);
                setLocalStorage(USER, user.name);
                setLocalStorage(USER_AGENCY, user.agency);
                setLocalStorage(USER_AGENCY_CODE, user.agency_code);
                setLocalStorage(USER_AGENCY_NAME, user.agency_name);
                setLocalStorage(USER_MOTORIST, user.motorist);
                setLocalStorage(TOKEN, user.token);
                mutations.setLogged(true);
                vaiParaUrl("/pesquisar");
              });
          },
          function () {
            // success callback
          },
          function (error) {
            // error callback
            console.log("Error adding NDEF listener " + JSON.stringify(error));
          }
        );
      }
    },
  },
};
</script>

<style lang="scss">
@import '../scss/variables';

.login {
  height: 100vh;
}

.presentation-login {
  background-color: $color-green-dark;
}

.presentation-login__img-logo {
  img {
    width: 160px;
  }
}

.presentation-login__img-logomarca {
  margin-top: 60px;
  margin-bottom: 50px;

  img {
    width: 247px;
  }
}

.presentation-login__history {
  width: 100%;
  padding: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.48);
  border-radius: 0;
  font-family: sans-serif;
}

.presentation-login__title {
  color: $color-green-text;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
}

.presentation-login__form {
  display: grid;
  align-content: end;
  gap: 10px;
  padding: 35px 30px 0 30px;
}

.presentation-login__button {
  background: $color-green-dark;
  color: white;
  font-weight: bold;

  width: 100%;
  padding: 14px;
}

.link_eulabs {
  margin-top: 40px;
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #808285;
  
  a {
    font-weight: bold;
    color: $color-green-brand;
    text-decoration: none;
  }
}

.text_version {
  margin-top: 10px;
  padding-bottom: 20px;
  width: 100%;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  color: $color-green-light;
}

.text_nfc {
  color: $color-green-brand;
  font-size: 16px;
  margin: 0;
  margin-top: 20px;
}

.login__newsApp {
  &--dialog {
    display: flex;
    justify-items: center;
    align-items: center;
    flex-direction: column;
    padding: 0 40px 20px 40px;

    h6 {
      font-size: 18px;
      margin: 0;
      margin-bottom: 30px;
    }

    img {
      filter: drop-shadow(-12px 23px 32px rgba(0, 0, 0, 0.5));
    }
  }

  &--title {
    margin-top: 20px;
    text-align: center;
    color: $color-green-dark;
    font-size: 14px;
    font-family: sans-serif;
    font-weight: 600;
    
  }

  &--description {
    text-align: center;
    color: #808285;
    font-family: sans-serif;
    font-size: 13px;
  }
}
</style>
